import React from 'react';
import GoodAtStuff from '../../components/GoodAtStuff/GoodAtStuff.react';
import './About.css'; // Make sure to create an About.css file

function About() {
  return (
    <div className="about-container">
        <GoodAtStuff />
    </div>
  );
}

export default About;